<template>
<v-content style="background-color:#173b76;">
  <v-container fluid :class="{enableBlur: loading}">
    <v-snackbar v-model="showInstanceLink"
      top dark color="#E53935" :timeout="timeout" class="subtitle-1">
      <span class="mr-2 text-wrap">Пријава за новчану помоћ је престала 20.09.2023. у 24 часа. Провера статуса пријаве као и пријава рекламација у вези са исплатом новчане помоћи су и даље омогућене. Како бисте проверили статус исплате за помоћ младима
      <span style="cursor: pointer; text-decoration: underline;" class="font-weight-medium pb-1 px-0 text-no-wrap" dark tile @click="gotoInstance()">пратите линк</span></span>
      <v-btn text
        @click="showInstanceLink = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-snackbar>
    <v-navigation-drawer floating class="d-none d-xl-flex d-lg-flex d-xl-none" width=356 color="white"
        :expand-on-hover="false" :mini-variant="false" :permanent="true" absolute dark
        style="border: none !important;">
        <v-row class="fill-height" no-gutters>
            <v-col cols=3 style="background-color: white;" align="center" class="pt-5">
                <v-sheet light>
                    <img style="flex-grow: unset;" height="110" src="~@/assets/images/grb.svg">
                </v-sheet>
            </v-col>
            <v-col cols=9 style="background-color:#173b76 !important;" class="pt-9 pl-4">
                <v-sheet light>
                    <v-row dense align="center" class="treasury-logo account-page">
                        <v-col style="flex-grow: unset; background-color: #173b76;">
                            <label class="white--text government-font font-weight-medium">РЕПУБЛИКА СРБИЈА</label>
                            <label class="white--text body-2 font-weight-medium">МИНИСТАРСТВО ФИНАНСИЈА</label>
                            <label class="white--text body-2 font-weight-medium">УПРАВА ЗА ТРЕЗОР</label>
                        </v-col>
                    </v-row>
                </v-sheet>
            </v-col>
        </v-row>
    </v-navigation-drawer>
    <v-row dense justify="center" class="d-none d-xl-flex d-lg-flex d-xl-none">
      <v-card min-height="80px"></v-card>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12" xs=12 sm=12 md=12 lg=5 xl=4 align-self="end">
        <v-row no-gutters>
          <v-col cols=12>
          <span class="government-headline-font white--text font-weight-medium" align-self="end" v-html="headline"></span>
          </v-col>
        </v-row>
        <v-row no-gutters class="mb-5">
          <v-col cols=12>
          <span class="display-1 white--text font-weight-medium" align-self="end" v-html="subHeadline"></span>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12" xs=12 sm=12 md=12 lg=4 xl=4>
        <v-card @click="registerAccount"
          :disabled="!registrationEnabled"
          tile
          class="header-part"
          min-height="135"
          dark>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline" v:>{{$t('account.registerAccount')}}</v-card-title>
              <v-card-text>{{$t('account.registerAccountSubTitle')}}</v-card-text>

              </div>
              <v-avatar
                class="mt-5 mr-5"
                size="65"
                tile>
                <img src="~@/assets/images/icons/register-account.svg">
              </v-avatar>
          </div>
      </v-card>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12" xs=12 sm=12 md=12 lg=4 xl=4>
        <v-card @click="validateAccount"
          tile
          class="second-header-part"
          min-height="135"
          dark>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
          <v-card-title class="headline">{{$t('account.validateAccount')}}</v-card-title>
          <v-card-text >{{$t('account.validateAccountSubTitle')}}</v-card-text>
              </div>
          <v-avatar
                class="mt-5 mr-5"
                size="65"
                tile>
                <img src="~@/assets/images/icons/validate-account.svg">
              </v-avatar>
          </div>
      </v-card>
      </v-col>
    </v-row>
    <v-row dense justify="center">
      <v-col cols="12" xs=12 sm=12 md=12 lg=4 xl=4>
        <v-card @click="reportIssue"
          :disabled="!reportIssueEnabled"
          tile
          class="third-header-part"
          min-height="135"
          dark>
          <div class="d-flex flex-no-wrap justify-space-between">
            <div>
              <v-card-title class="headline">{{$t('account.reportIssue')}}</v-card-title>
              <v-card-text>{{$t('account.reportIssueTitle')}}</v-card-text>
            </div>
          <v-avatar
                class="mt-5 mr-5"
                size="65"
                tile>
                <img src="~@/assets/images/icons/report-issue.svg">
              </v-avatar>
          </div>
      </v-card>
      </v-col>
    </v-row>
  </v-container>
</v-content>
</template>

<script>
import Vue from 'vue'
import { isUserActive, logout } from '@/router/auth'
import { EventBus } from '@/router/bus'
import Moment from 'moment'

export default {
  name: 'startpage',
  data () {
    return {
      loading: true,
      isTiny: false,
      snackbar: true,
      timeout: 0,
      user: {},
      loginVisibility: 'none',
      loginError: false,
      connectionError: false,
      showInstanceLink: Vue.$config.service_config[Vue.$config.service_name].showInstanceLink,
      instanceLink: Vue.$config.service_config[Vue.$config.service_name].instanceLink,
      headline: Vue.$config.service_config[Vue.$config.service_name].headline,
      subHeadline: Vue.$config.service_config[Vue.$config.service_name].subHeadline,
      registrationStartDate: Vue.$config.service_config[Vue.$config.service_name].registrationStartDate,
      registrationEndDate: Vue.$config.service_config[Vue.$config.service_name].registrationEndDate,
      reportIssueEndDate: Vue.$config.service_config[Vue.$config.service_name].reportIssueEndDate,
      inputEndDateMessage: Vue.$config.service_config[Vue.$config.service_name].inputEndDateMessage
    }
  },
  created () {
    if (isUserActive()) {
      this.$router.push('/dashboard')
    } else {
      logout()
      EventBus.$emit('logged-out', '')
    }
  },
  computed: {
    registrationStarted () {
      return Moment() > Moment(this.registrationStartDate)
    },
    registrationEnabled () {
      return Moment() < Moment(this.registrationEndDate)
    },
    reportIssueEnabled () {
      return Moment() < Moment(this.reportIssueEndDate)
    }
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  mounted () {
    this.loading = false
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    registerAccount () {
      this.$router.push({ name: 'register-account' })
    },
    validateAccount () {
      this.$router.push({ name: 'validate-account' })
    },
    reportIssue () {
      this.$router.push({ name: 'report-issue' })
    },
    onResize () {
      this.isTiny = window.innerWidth < 400
    },
    gotoInstance () {
      window.open(this.instanceLink, '_blank')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
    /*@import '../assets/css/login.scss';*/
    // @import '../assets/scss/main.scss';
    .display-4{
      padding-bottom: 50px;
      font-size: 45px;
    }
    .treasury-logo {
        margin: 0 auto;
        img {
          width: 55px;
        }
        label {
            white-space: nowrap;
            display: block;
            margin: 0px;
        }
    }
    .heavy-text {
    font-weight: 800 !important;
    }
    .image-block{
      background-color:#007bff
    }

    .heavier-text {
        font-weight: 600;
    }
    .text-center{
      padding-bottom: 50px;
    }

    .option-subtitle {
      font-size: 14px;
      font-weight: 400;
      letter-spacing: 0.1px;
    }

  .header-part {
    background-image: linear-gradient(90deg, #d72136 0%, #69305a 100%);
  }
  .second-header-part {
    background-image: linear-gradient(90deg, #19437b 40%, #0f2542 100%);
  }

  .third-header-part {
    background-image: linear-gradient(90deg, #7d98b7 0%, #4d5e70 100%);
  }
  .small-header-part {
    background-image: linear-gradient(90deg, #073f7b 0%, #69305a 100%);
  }
  .government-font {
    font-size: 28px;
  }
  .government-headline-font {
    font-size: 42px;
    line-height: 50px !important;
  }

</style>
